var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenBank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_756_8478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4788 7.623C12.5037 7.64777 12.5234 7.67722 12.5369 7.70963C12.5503 7.74205 12.5573 7.77681 12.5573 7.81191C12.5573 7.84701 12.5503 7.88177 12.5369 7.91418C12.5234 7.9466 12.5037 7.97604 12.4788 8.00082L4.44498 16H0V11.555L8.00096 3.52117C8.02573 3.49631 8.05518 3.47658 8.08759 3.46312C8.12001 3.44966 8.15477 3.44273 8.18987 3.44273C8.22497 3.44273 8.25973 3.44966 8.29214 3.46312C8.32456 3.47658 8.354 3.49631 8.37878 3.52117L12.4788 7.623ZM15.4774 2.49616L13.5038 0.522592C13.1689 0.187967 12.7149 0 12.2415 0C11.768 0 11.314 0.187967 10.9791 0.522592L9.30956 2.19212C9.25962 2.24213 9.23156 2.30992 9.23156 2.38059C9.23156 2.45127 9.25962 2.51905 9.30956 2.56906L13.4309 6.69044C13.4809 6.74039 13.5487 6.76844 13.6194 6.76844C13.6901 6.76844 13.7579 6.74039 13.8079 6.69044L15.4774 5.02091C15.812 4.68601 16 4.23196 16 3.75853C16 3.28511 15.812 2.83106 15.4774 2.49616Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_756_8478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenBank);
export default __webpack_public_path__ + "static/media/pen_bank.880dc03a23e3438c77c4b1365bc8ef98.svg";
export { ForwardRef as ReactComponent };